import React from 'react';
import 'bootstrap';
import $ from 'jquery';

const CtaMedia = (props) => {
  function playCtaMediaVideo(e) {
    e.preventDefault();
    let videoSrc = document.getElementById(props.btnId).getAttribute(`data-src`);

    $(`#${props.target}`).on('hide.bs.modal', function () {
      $(`#${props.iframeId}`).attr('src', '');
    });

    $(`#${props.target}`).on('shown.bs.modal', function () {
      $(`#${props.iframeId}`).attr('src', `${videoSrc}?autoplay=1&amp&vq=large;modestbranding=1&amp;showinfo=0`);
    });
  }

  return (
    <div className='ctaMediaContainer'>
      <div className='cta-btn-media'>
        <button
          id={props.btnId}
          onClick={playCtaMediaVideo}
          className={`cta-btn media ${props.theme && props.theme === 'light' ? 'text-white' : ''}`}
          data-toggle='modal'
          data-src={props.url}
          data-target={'#' + props.target}
        > 
          {props.theme && props.theme === 'light' ? (
            <img src='//cdn.shopify.com/s/files/1/0268/0337/2125/files/LightPlayButton.svg?13568' alt='Play Button' />
          ) : (
            <img src='//cdn.shopify.com/s/files/1/0268/0337/2125/files/DarkPlayButton.svg?15263' alt='Play Button' />
          )}
          <span>{props.text}</span>
        </button>
      </div>
      <div
        className='modal fade'
        id={props.target}
        tabIndex='-1'
        role='dialog'
        aria-labelledby={props.label}
        aria-hidden='true'
      >
        <div className='modal-dialog modal-dialog-centered' role='document'>
          <div className='modal-content'>
            <div className='modal-header'>
              <button className='close' data-dismiss='modal' aria-label='Close'>
                <p>Close</p>
                <span aria-hidden='true'></span>
              </button>
            </div>
            <div className='modal-body'>
              <div className='embed-responsive embed-responsive-16by9'>
                {props.url.includes('youtube') ? (
                  <iframe
                    className='embed-responsive-item'
                    src=''
                    id={props.iframeId}
                    allowscriptaccess='always'
                    allow='autoplay'
                  />
                ) : (
                  <video
                    className='embed-responsive-item'
                    src=''
                    id={props.iframeId}
                    allowscriptaccess='always'
                    allow='autoplay'
                    autoPlay
                    controls
                    playsInline
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CtaMedia;
